import Header from '../components/Header';
import { Leads } from '../components/Leads';

export function LeadsPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4">
        <Header />
        <main className="py-6">
          <h1 className="text-2xl font-bold mb-6">Leads Dashboard</h1>
          <Leads />
        </main>
      </div>
    </div>
  );
} 